<script setup>
import { onMounted, ref, watch, inject, defineExpose, defineProps } from 'vue';
import i18n from "@/i18n"
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import { getDashboardIndex_standard_list } from "@/service/apiList/dashboard"
import PreviewImg from "@/components/common/PreviewImg";
import vectorSvg from "@/assets/images/svg/vector.svg"
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
import { getFileUrl } from "@/service"
import { showMessage } from "@/utils/hooks/message"
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const tableInfo = ref([])
const showTable = inject('showTable')
const tableGroupAllInfo = ref({}) // 所有组的数据
const tableAllInfo = ref([]) // 当前组所有的数据
const selectedProductId = ref('')
const props = defineProps({
    category: {
        type: String,
        required: true,
        default: '3'
    },
    // 只有感官舒适性才会传这个
    selectedFabricData: {
        type: Object,
        required: false,
        default: () => { }
    },
})
const table_head = ref([
    { name: 'NO.', width: '2%', checked: true },
    { name: getLangValue("attribute.indicator_name"), width: '10%', key: 'name', checked: true, type: 'name' }, //指标名称
    { name: getLangValue("dashboard.indicatorValues"), width: '8.5%', key: 'value', checked: true }, //指标数值
    // { name: getLangValue("hscode.threshold"), width: '8.5%', key: 'threshold', checked: true }, //阈值
    { name: getLangValue("dashboard.evaluate"), width: '8.5%', key: 'value&report', checked: true }, //评价
    { name: getLangValue("dashboard.Indicatorunit"), width: '8.5%', key: 'unit', checked: true }, //单位
    { name: getLangValue("attribute.reference"), width: '13%', key: 'reference', checked: true, type: 'reference' },
    { name: getLangValue("dashboard.Testingcertificate"), width: '8.5%', key: 'Testingcertificate', checked: true },
    // { name: getLangValue("dashboard.TestingDate"), width: '8.5%', key: 'certification_date', checked: true },
    { name: getLangValue("product-template.testingOrganization"), width: '8.5%', key: 'testing_institution', checked: true },
    { name: getLangValue("dashboard.Identificationtestinginstitution"), width: '8.5%', key: 'qrcodeImgUrl', checked: true },
    { name: getLangValue("dashboard.Certificationdate"), width: '8.5%', key: 'certification_date', checked: true },
    { name: getLangValue("dashboard.Validitycertification"), width: '8.5%', key: 'validity_period_of_certification', checked: true },
    { name: getLangValue("dashboard.Certificationbody"), width: '8.5%', key: 'certification_body', checked: true },
])

const pageSizeOption = [10, 20, 30, 40, 50]
const { total, currentPage, pageSize, pageOption } = usetablePageNation()
// const type = ref('')
const subGroupNameList = ref([]) // 子组名list
const subGroupNamekeyList = ref([]) // 子组名中英文对照list
const groupNameSubGroupNamekeyword = ref('') // 用来搜索组名 子组名的条件
const activeSubGroup = ref('特殊指标') // 特殊指标的key
const allGroupList = ref([]) // 所有组名数据  后台直接返回的数据
const loading = ref(false)
const noChildrengroupObj = ref({}) //  当前选中组是否有子组  标识一下
const getDataList = async () => {
    // 获取所有数据
    loading.value = true
    //获取数据
    let params = {
        category_id: props.category,
        id: selectedProductId.value,
    }
    const resp = await getDashboardIndex_standard_list(params);
    loading.value = false
    if (resp.code == 0) {
        // tableGroupAllInfo.value = resp.payload.data;
        allGroupList.value = resp.payload;
        if (resp.payload.length == 0) return
        setdata1();
    }
}

const setdata1 = () => {
    // 设置分组数据
    subGroupNameList.value = [] // 子组名list
    tableGroupAllInfo.value = {} // 所有组的数据
    tableAllInfo.value = []     // 当前组所有的数据
    subGroupNamekeyList.value = []; //  子组名key list 方便取数据
    if (allGroupList.value.length == 0) return
    for (const item in allGroupList.value) {
        const { group_name, children, index_standard_list, special_index_standard_list } = allGroupList.value[item]
        // 包含
        if (group_name == groupNameSubGroupNamekeyword.value) {
            if (typeof children != 'undefined') {
                for (const item1 in children) {
                    const { group_name: group_name1, group_name_en, index_standard_list: index_standard_list1 } = children[item1]
                    tableGroupAllInfo.value[group_name + group_name1] = index_standard_list1
                    subGroupNameList.value.push(group_name1)
                    subGroupNamekeyList.value.push({ group_name: group_name1, group_name_en });
                }
                noChildrengroupObj.value[group_name] = true
            } else {
                subGroupNameList.value.push(getLangValue('dashboard.special_indicators'))
                tableGroupAllInfo.value[group_name] = index_standard_list
                tableGroupAllInfo.value[group_name + getLangValue('dashboard.special_indicators')] = special_index_standard_list
                noChildrengroupObj.value[group_name] = false
            }
        }

    }
    if (subGroupNameList.value.length == 1) {
        // pef 默认展示全部
        activeSubGroup.value = ''
    } else {
        activeSubGroup.value = subGroupNameList.value[0]
    }
    if (typeof (groupNameSubGroupNamekeyword.value + activeSubGroup.value) != 'undefined') {
        tableAllInfo.value = tableGroupAllInfo.value[groupNameSubGroupNamekeyword.value + activeSubGroup.value]
    }
    // console.log(subGroupNamekeyList.value);
}

// const setdata = () => {
//     // 筛选组名的数据
//     subGroupNameList.value = []
//     tableGroupAllInfo.value = {}
//     tableAllInfo.value = []
//     if (props.category == 3 || props.category == 6 || props.category == 4 || props.category == 2) {
//         //质量板块 三层组
//         //显示的当前组下面的子组以及所有特殊指标
//         if (groupNameSubGroupNamekeyword.value == 'all') {
//             let arr = allGroupList.value
//             if (arr.length) {
//                 for (const item in arr[0].children) {
//                     const { group_name, index_standard_list } = arr[0].children[item]
//                     subGroupNameList.value.push(group_name)
//                     tableGroupAllInfo.value[group_name] = index_standard_list
//                 }
//                 // console.log(subGroupNameList.value);
//                 // 默认显示第一个指标
//                 activeSubGroup.value = subGroupNameList.value[0]
//                 tableAllInfo.value = tableGroupAllInfo.value[activeSubGroup.value]
//             }
//         } else {
//             let arr = allGroupList.value.filter(item => item.group_name == groupNameSubGroupNamekeyword.value)
//             if (arr.length) {
//                 for (const item in arr[0].children) {
//                     const { group_name, index_standard_list } = arr[0].children[item]
//                     subGroupNameList.value.push(group_name)
//                     tableGroupAllInfo.value[group_name] = index_standard_list
//                 }
//                 // console.log(subGroupNameList.value);
//                 // 默认显示第一个指标
//                 activeSubGroup.value = subGroupNameList.value[0]
//                 tableAllInfo.value = tableGroupAllInfo.value[activeSubGroup.value]
//             }
//         }

//     }
//     else if (props.category == 5) {
//         // pef先显示全部 当前组的全部数据
//         // 增加一个特殊指标
//         subGroupNameList.value = ['特殊指标']
//         activeSubGroup.value = ''
//         let arr = allGroupList.value.filter(item => item.group_name == groupNameSubGroupNamekeyword.value)
//         for (const item in arr) {
//             const { index_standard_list } = arr[item]
//             // 获取全部指标数据
//             tableAllInfo.value = [...index_standard_list, ...tableAllInfo.value]
//         }
//     }
// }

// const updataPefData = () => {
//     // pef单独处理
//     // 获取当前分组全部指标
//     let arr = allGroupList.value.filter(item => item.group_name == groupNameSubGroupNamekeyword.value)
//     activeSubGroup.value = ''
//     tableAllInfo.value = []
//     if (arr.length) {
//         tableAllInfo.value = [...arr[0].index_standard_list]
//     }
// }

// const showPefSpecial = () => {
//     // pef单独处理特殊指标
//     // 当前组的特殊指标
//     let arr = allGroupList.value.filter(item => item.group_name == groupNameSubGroupNamekeyword.value)
//     if (arr.length) {
//         tableAllInfo.value = [...arr[0].special_index_standard_list]
//     }
// }

const setTableData = () => {
    // 根据分页 
    // 根据group筛选
    let startIndex = ((currentPage.value - 1) * pageSize.value) - 1 < 0 ? 0 : ((currentPage.value - 1) * pageSize.value);
    let endIndex = startIndex + pageSize.value;
    // 第一种根据显示某个组的数据  第二种显示组名-子组的数据  第三种显示所有的特殊数据跟组名无关
    if (typeof tableAllInfo.value == 'undefined') return
    total.value = tableAllInfo.value.length
    tableInfo.value = JSON.parse(JSON.stringify([...tableAllInfo.value.slice(startIndex, endIndex)]))
    console.log(tableAllInfo.value);

    tableInfo.value.forEach(async item => {
        // 如果检测机构有id才显示二维码
        if (item.testing_institution_user && item.testing_institution_user?.id) {
            // 需要加id
            const reps = await makeQrCode({ type: 1, id: item?.testing_institution_user?.id })
            if (reps) {
                item.qrcodeImgUrl = reps
            }
        }
        // 判断哪些值需要改变
        if (props.selectedFabricData[`chart-${groupNameSubGroupNamekeyword.value}`] && props.selectedFabricData[`chart-${groupNameSubGroupNamekeyword.value}`].length == 2) {
            let product_id = props.selectedFabricData[`chart-${groupNameSubGroupNamekeyword.value}`][0]
            let fabric_id = props.selectedFabricData[`chart-${groupNameSubGroupNamekeyword.value}`][1]
            if (selectedProductId.value == product_id) {
                const obj = allGroupList.value.find(item => item.group_name == groupNameSubGroupNamekeyword.value)
                if (obj) {
                    const fabric_list = obj.fabric_list || [];
                    let selectedFabric = fabric_list.find(item => item.id == fabric_id)
                    if (selectedFabric && selectedFabric.index_standard_list) {
                        // 去查找这个name
                        let obj1 = selectedFabric.index_standard_list.find(item1 => item1.index_standard.name == item.index_standard.name)
                        if (obj1) {
                            if(!item?.database_index_standard  ) {
                                item.database_index_standard ={
                                    value: ''
                                }
                            }
                            item.database_index_standard.value = obj1.database_index_standard.value || '-'
                        }
                    }
                }
            }
        }

    })
}

// const search = () => {
//     //搜索
//     currentPage.value = 1;
//     setTableData()
// }

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

// const getChecked = () => {
//     return table_head.value.filter(item => item.checked).length
// }

// const getValueAndReport = () => {
//     // 根据value和report显示值
//     // !value    ''
//     // value && report.length > 0   通过认证
//     // value && report.length === 0   通过检测
//     // if (!info.value) {
//     //     return '';
//     // }
//     // if (info.report.length > 0) {
//     //     return getLangValue('business_products_management.certificationPassed');
//     // } else {
//     //     return getLangValue('business_products_management.testedSuccessfully');
//     // }
//     // 2024-10-28 目前数据都是达标的  全显示通过
//     return getLangValue('dashboard.quality.pass');
// }

const showReport = async (report) => {
    // 显示report里面的文件信息
    // 如果是图片才展示
    const resp = await getFileUrl({ attachments: report[0] })
    if (resp.code == 0) {
        // 判断是否图片
        if (resp.payload[0].name.match(/\.(jpg|jpeg|png|gif)$/i)) {
            activeImageSrc.value = resp.payload[0].url;
            showPreviewImg.value = true;
        } else {
            // 提示无法预览
            showMessage('info', getLangValue('base.not_support_preview'))
        }
    }
}

const getsubName = (name) => {
    // 获取子组名
    // console.log(subGroupNamekeyList.value);
    if (subGroupNamekeyList.value.length) {
        let obj = subGroupNamekeyList.value.find(item => item.group_name == name);
        return i18n.global.locale == 'en' ? obj.group_name_en : obj.group_name
    }
    return ''
}

onMounted(() => {
    // getIndicatorCategory();
    // setdata1();
    // pef特殊处理 去掉评价
    if (props.category != '3') {
        table_head.value = [
            { name: 'NO.', width: '2%', checked: true },
            { name: getLangValue("attribute.indicator_name"), width: '10%', key: 'name', checked: true, type: 'name' }, //指标名称
            { name: getLangValue("dashboard.indicatorValues"), width: '8.5%', key: 'value', checked: true }, //指标数值
            // { name: getLangValue("hscode.threshold"), width: '8.5%', key: 'threshold', checked: true }, //阈值
            // { name: getLangValue("dashboard.evaluate"), width: '8.5%', key: 'value&report', checked: true }, //评价
            { name: getLangValue("dashboard.Indicatorunit"), width: '8.5%', key: 'unit', checked: true }, //单位
            { name: getLangValue("attribute.reference"), width: '13%', key: 'reference', checked: true, type: 'reference' },
            { name: getLangValue("dashboard.Testingcertificate"), width: '8.5%', key: 'Testingcertificate', checked: true },
            // { name: getLangValue("dashboard.TestingDate"), width: '8.5%', key: 'certification_date', checked: true },
            { name: getLangValue("product-template.testingOrganization"), width: '8.5%', key: 'testing_institution', checked: true },
            { name: getLangValue("dashboard.Identificationtestinginstitution"), width: '8.5%', key: 'qrcodeImgUrl', checked: true },
            { name: getLangValue("dashboard.Certificationdate"), width: '8.5%', key: 'certification_date', checked: true },
            { name: getLangValue("dashboard.Validitycertification"), width: '8.5%', key: 'validity_period_of_certification', checked: true },
            { name: getLangValue("dashboard.Certificationbody"), width: '8.5%', key: 'certification_body', checked: true },
        ]
    }
})

watch(pageSize, () => {
    currentPage.value = 1;
    setTableData();
})

watch(currentPage, () => {
    setTableData();
})

watch(tableAllInfo, () => {
    currentPage.value = 1;
    setTableData();
}, { deep: true })


watch(selectedProductId, () => {
    // 查询产品的指标信息
    getDataList();
})

watch(activeSubGroup, () => {
    // 子组名切换
    tableAllInfo.value = tableGroupAllInfo.value[groupNameSubGroupNamekeyword.value + activeSubGroup.value]
    // 切换玩数据 组装table分页数据
    setTableData();
})

watch(groupNameSubGroupNamekeyword, () => {
    // 组名切换了  子组名也需要更新 
    // 组名切换了   可能没有子组  显示指标
    setdata1()
}, { deep: true })

watch(props.selectedFabricData, (val) => {
    //监听值
    // 必须有两个数值
    // if (val[`chart-${groupNameSubGroupNamekeyword.value}`] && val[`chart-${groupNameSubGroupNamekeyword.value}`].length == 2) {
    //     setTableData();
    // } else {
    //     // 变为原来的值
    //     setTableData();
    // }
    console.log(val);
    setTableData();
}, { deep: true })

defineExpose({
    subGroupNameList,
    groupNameSubGroupNamekeyword,
    selectedProductId,
    activeSubGroup,
    noChildrengroupObj
})


</script>
<template>
    <div class="digitalPassportTable1 px-3 py-2 " style="height: calc(100% - 1rem) ">
        <div class="d-flex justify-content-between align-items-center">
            <div class="search d-flex align-items-center">
                <!-- <div class="form-icon">
                    <input style="width: 246px;" clearable class="form-control form-control-icon" v-model="type"
                        required :placeholder="$t('dashboard.input4')" />
                    <i class="ri-search-line"></i>
                </div> -->
                <i class="ri-arrow-go-back-line cursor-pointer mx-2" style="font-size: 20px;" @click="showTable = 0" />
                <!-- <input style="width: 246px;" clearable class="form-control form-control-icon" v-model="type" required
                    :placeholder="$t('hscode.indicatorName')" /> -->
                <!-- <el-select v-model="type" filterable clearable :placeholder="$t('dashboard.quality.inputtext')"
                    style="width: 240px; height: 38px;">
                    <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.id" />
                </el-select> -->
                <!-- 子组名list -->
                <!-- <span class="cursor-pointer" @click="activeSubGroup = 'special'"
                    :class="activeSubGroup === 'special' ? 'activeGroup' : ''">
                    {{ getLangValue("dashboard.quality.special_indicators") }}
                </span> -->
                <span class="mx-3 cursor-pointer" v-for="(item, key) in subGroupNameList" :key="key">
                    <span @click="activeSubGroup = item" :class="activeSubGroup === item ? 'activeGroup' : ''">
                        {{ getsubName(item) }}
                    </span>
                </span>
            </div>
            <!-- <div class="d-flex">
                <div class="d-flex" style="color: white;">
                    <button id="btnGroupVerticalDrop1" type="button" class="btn dropdown-toggle"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        style="padding: 0 3px; color: white;">
                        <i class="ri-filter-line"></i>{{ getChecked() }}{{ $t('dashboard.quality.selectLegnth') }}
                    </button>
                    <div class="dropdown-menu " aria-labelledby="btnGroupVerticalDrop1">
                        <template v-for="(hItem) in table_head" :key="hItem">
                            <div class="m-2 d-flex align-items-center">
                                <input class="form-check-input mt-0 mx-2" type="checkbox" v-model="hItem.checked"
                                    aria-label="Checkbox for following text input">
                                <span>{{ hItem.name }}</span>
                            </div>
                        </template>
</div>
</div>
<button type="button" class="btn btn-success mx-3" @click="search()" style="min-width: 93px;">
    {{ $t("base.search") }}
</button>
</div> -->
        </div>
        <div style="flex-direction: column; height: calc(100% - 40px);">
            <div class="my-table my-2" id="my-table">
                <!-- 表格信息 -->
                <div style="height:calc(100% - 50px); overflow-y: auto;" class="my-scroll-bar">
                    <table class="table table-nowrap ">
                        <!-- table-nowrap -->
                        <thead class="table-light">
                            <tr>
                                <template v-for="(head, index) in table_head.filter(item => item.checked)" :key="index">
                                    <th v-if="head.type == 'reference'" scope="col"
                                        style="color: #2E404C;min-width: 200px">
                                        <div class="d-flex align-items-center">{{ head.name }}</div>
                                    </th>
                                    <th v-else scope="col"
                                        style="color: #2E404C; min-width:100px; max-width: 120px; white-space: normal; word-wrap: break-word;"
                                        :width="head.width">
                                        <div class="d-flex align-items-center"
                                            :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'">{{
                                                head.name }}</div>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                                <td v-for="(item, kk) in table_head.filter(item => item.checked)" :key="kk"
                                    style="word-wrap: break-word; white-space: normal;">
                                    <span v-if="item.key === 'qrcodeImgUrl'">
                                        <img v-if="info.qrcodeImgUrl" :src="info.qrcodeImgUrl" class="cursor-pointer"
                                            style="width: 48px;height: 48px;" @click="showImageCode(info.qrcodeImgUrl)">
                                        <span v-else>-</span>
                                    </span>
                                    <span v-else>
                                        <div v-if="item.key == 'reference'" :title="i18n.global.locale == 'en' ?
                                            info.index_standard?.reference_en : info.index_standard[item.key]"
                                            style="width: 200px; max-height: 60px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                            {{ kk == 0 ? index + 1 : i18n.global.locale == 'en' ?
                                                info.index_standard?.reference_en : info.index_standard[item.key] }}</div>
                                        <div v-else-if="item.key == 'value&report'">
                                            <span
                                                v-if="info.database_index_standard && info.database_index_standard.value">
                                                {{ info.database_index_standard &&
                                                    info.database_index_standard.is_up_to_standard ?
                                                    getLangValue('dashboard.quality.pass') :
                                                    getLangValue('dashboard.quality.fail') }}
                                            </span>
                                            <span v-else>-</span>
                                        </div>
                                        <div v-else-if="item.key == 'Testingcertificate'">
                                            <img :src="vectorSvg" style="width: 24px;" class="cursor-pointer"
                                                @click="showReport(info.database_index_standard.report)"
                                                v-if="info.database_index_standard && info.database_index_standard.report && info.database_index_standard.report.length" />
                                            <span v-else>-</span>
                                        </div>
                                        <div v-else-if="item.key == 'unit'">
                                            {{ i18n.global.locale == 'en' ? info.index_standard?.unit_en || '-' :
                                                info.index_standard[item.key] || '-' }}
                                        </div>
                                        <div v-else-if="item.key == 'value'">
                                            {{ (info.database_index_standard && info.database_index_standard[item.key])
                                                || '-'
                                            }}
                                        </div>
                                        <div
                                            v-else-if="item.key == 'testing_institution' || item.key == 'certification_date' || item.key == 'validity_period_of_certification' || item.key == 'certification_body'">
                                            {{ (info.database_index_standard && info.database_index_standard[item.key])
                                                || '-'
                                            }}
                                        </div>
                                        <div v-else-if="item.key == 'threshold'">
                                            {{ info.index_standard_type && info.index_standard_type[item.key] }}
                                        </div>
                                        <div v-else-if="item.key == 'name'">
                                            <!-- 特殊指标 -->
                                            <span>
                                                <i class="ri-bookmark-line"
                                                    v-if="info.index_standard_type && info.index_standard_type.is_specific"
                                                    style="color: #0AB39C;" />
                                                {{ i18n.global.locale == 'en' ? info.index_standard?.name_en
                                                    : info.index_standard?.name }}</span>
                                        </div>
                                        <span v-else>{{ kk == 0 ? index + 1 : info[item.key] }}</span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 分页 -->
                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                    :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 my-3 my-pagination">
                </Pagination>
            </div>
        </div>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
        </PreviewImg>
    </div>

</template>
<style scoped lang="scss">
.digitalPassportTable {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            height: 100%;
            background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: white;
        }


        :deep(.el-input__inner) {
            color: white;
        }

        .form-icon {
            display: inline-block;

            i {
                color: white
            }
        }

        .form-control {
            background-color: #4a5056;
            color: white;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: white;
        }

        .my-pagination {
            color: white;

            :deep(.page_total) {
                color: white !important;
            }
        }
    }
}

.digitalPassportTable1 {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            height: 100%;
            // background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: #2E404C;
        }


        :deep(.el-input__inner) {
            color: #2E404C;
        }

        .form-icon {
            display: inline-block;

            i {
                color: #2E404C
            }
        }

        .form-control {
            // background-color: #4a5056;
            color: #2E404C;
            display: inline-block;
        }

        .activeGroup {
            color: #0AB39C;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: #2E404C;
        }

        .my-pagination {
            color: #2E404C;

            :deep(.page_total) {
                color: #2E404C !important;
            }
        }
    }
}
</style>